import { getCollectorTierDefinitionForRole, shouldShowCollectorTierBadge } from "../utils/collectorTiers";

const TONE_STYLES = Object.freeze({
  bronze: Object.freeze({
    background: "#f59e0b",
    border: "#b45309",
    accent: "#fef3c7",
    text: "#78350f"
  }),
  silver: Object.freeze({
    background: "#cbd5e1",
    border: "#64748b",
    accent: "#f8fafc",
    text: "#334155"
  }),
  gold: Object.freeze({
    background: "#facc15",
    border: "#ca8a04",
    accent: "#fef9c3",
    text: "#713f12"
  })
});

const SIZE_STYLES = Object.freeze({
  sm: Object.freeze({ iconEm: 0.96, labelEm: 0.74, gapEm: 0.24 }),
  md: Object.freeze({ iconEm: 1.14, labelEm: 0.82, gapEm: 0.4 }),
  lg: Object.freeze({ iconEm: 1.24, labelEm: 0.86, gapEm: 0.45 })
});

export default function CollectorTierBadge({
  tier,
  role = "collector",
  size = "md",
  showLabel = false,
  title = ""
}) {
  if (!shouldShowCollectorTierBadge(role)) {
    return null;
  }

  const definition = getCollectorTierDefinitionForRole(tier, role);
  const tone = TONE_STYLES[definition.iconTone] || TONE_STYLES.bronze;
  const scale = SIZE_STYLES[size] || SIZE_STYLES.md;

  return (
    <span
      title={title || definition.label}
      aria-label={definition.label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: `${scale.gapEm}em`,
        verticalAlign: "middle",
        lineHeight: 1,
        fontSize: "inherit",
        flexShrink: 0
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: `${scale.iconEm}em`,
          height: `${scale.iconEm}em`,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flex: `0 0 ${scale.iconEm}em`
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" style={{ display: "block", overflow: "visible" }}>
          <rect x="3.7" y="1.9" width="9.6" height="14.2" rx="1.3" fill={tone.background} />
          <rect x="4.55" y="2.9" width="7.9" height="1.55" rx="0.55" fill="#fff8" />
          <circle cx="11.5" cy="3.68" r="0.38" fill={tone.border} opacity="0.7" />
          <rect x="4.55" y="5" width="7.9" height="5.2" rx="0.65" fill={tone.accent} />
          <path d="M5.25 9.45C6.3 8.1 7.15 7.2 8.35 7.2C9.15 7.2 9.8 7.65 10.45 8.35C10.95 8.88 11.3 9.25 12.45 9.25" stroke={tone.border} strokeWidth="0.82" strokeLinecap="round" opacity="0.34" />
          <rect x="4.55" y="10.95" width="7.9" height="4.25" rx="0.6" fill="#fff7" />
          <path d="M5.45 12.2H9.85" stroke={tone.border} strokeWidth="0.88" strokeLinecap="round" opacity="0.42" />
          <path d="M5.45 13.5H8.95" stroke={tone.border} strokeWidth="0.88" strokeLinecap="round" opacity="0.3" />
          <path d="M5.45 14.45H8.15" stroke={tone.border} strokeWidth="0.88" strokeLinecap="round" opacity="0.24" />
          <circle cx="13.45" cy="12.45" r="4.28" fill="#ffffff" stroke={tone.border} strokeWidth="1.25" />
          <path d="M16.3 15.3L18.25 17.25" stroke={tone.border} strokeWidth="1.55" strokeLinecap="round" />
          <text x="13.45" y="13.95" textAnchor="middle" fontSize="4.7" fontWeight="700" fill={tone.text}>{definition.shortLabel.replace("Tier ", "")}</text>
        </svg>
      </span>
      {showLabel ? (
        <span style={{ fontSize: `${scale.labelEm}em`, fontWeight: 700, color: tone.text, whiteSpace: "nowrap", lineHeight: 1 }}>
          {definition.shortLabel}
        </span>
      ) : null}
    </span>
  );
}